import { render, staticRenderFns } from "./AccountEdit.vue?vue&type=template&id=6b7f355a&"
import script from "./AccountEdit.vue?vue&type=script&lang=ts&"
export * from "./AccountEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AccountEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports